import { gql } from '@apollo/client';

export const DELETE_CREATIVES_ASSET_BY_ID_V5 = gql`
  mutation DeleteCreativesAssetByIDV5($creativeId: String!, $assetId: String!) {
    deleteCreativesAssetByIDV5(creativeId: $creativeId, assetId: $assetId)
  }
`;
